<template>
  <div class="app-container">
    <!-- 筛选区域 -->
    <div class="filter-area">
      <el-form :model="searchForm" class="filter-form" label-width="70px">
        <el-form-item label="搜索">
          <el-input
            v-model="searchForm.keyword"
            placeholder="员工/客户/电话"
            clearable
            style="width: 270px"
            @keyup.enter="fetchDaodianList"
          />
        </el-form-item>

        <!-- 到店类型筛选 -->
        <el-form-item label="到店类型">
          <el-select
            v-model="searchForm.leixingId"
            placeholder="选择类型"
            clearable
            style="width: 180px"
            @change="handleFilterChange"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="item in leixingList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 客户意向筛选 -->
        <el-form-item label="客户意向">
          <el-select
            v-model="searchForm.yixiangdu"
            placeholder="选择意向"
            clearable
            style="width: 180px"
            @change="handleFilterChange"
          >
            <el-option label="全部" value="" />
            <el-option label="高意向" value="A" />
            <el-option label="中意向" value="B" />
            <el-option label="低意向" value="C" />
          </el-select>
        </el-form-item>

        <!-- 跟进时间筛选 -->
        <el-form-item label="跟进时间">
          <el-select
            v-model="searchForm.followTime"
            placeholder="选择时间"
            clearable
            style="width: 180px"
            @change="handleFilterChange"
          >
            <el-option label="全部" value="" />
            <el-option label="7天内更新" value="within7" />
            <el-option label="超7天未更新" value="over7" />
            <el-option label="超15天未更新" value="over15" />
            <el-option label="本月到店" value="month_arrival" />
          </el-select>
        </el-form-item>

        <!-- 数据状态筛选 -->
        <el-form-item label="数据状态">
          <el-select
            v-model="searchForm.lost"
            placeholder="选择状态"
            clearable
            style="width: 180px"
            @change="handleFilterChange"
          >
            <el-option label="全部" value="" />
            <el-option label="正常数据" value="false" />
            <el-option label="已流失数据" value="true" />
          </el-select>
        </el-form-item>

        <!-- 签约状态筛选 -->
        <el-form-item label="签约状态">
          <el-select
            v-model="searchForm.signed"
            placeholder="选择状态"
            clearable
            style="width: 180px"
            @change="handleFilterChange"
          >
            <el-option label="全部" value="" />
            <el-option label="已签约" value="true" />
          </el-select>
        </el-form-item>

        <el-form-item label="到店时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            style="width: 250px"
            @change="handleDateRangeChange"
            @clear="handleDateClear"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="fetchDaodianList" size="mini">
            查询
          </el-button>
          <el-button @click="resetSearch" size="mini">
            重置
          </el-button>
          <el-button type="success" @click="openAddDaodianPage" size="mini">
            新增
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 固定提示栏：所有人可见 -->
    <div class="loss-tip">
      <i class="el-icon-info-circle tip-icon"></i>
         道友，流失数据领取一条，给你追加一条（不设限制了哈）
    </div>

    <!-- 数据总数 + 加载状态 -->
    <div class="info-bar">
      <div class="total-count" v-if="total > 0">
        共 {{ total }} 条数据
      </div>
      <div class="loading" v-if="isLoading">
        <el-skeleton active /> 加载中...
      </div>
    </div>

    <!-- 卡片式数据列表 -->
    <div class="card-list">
      <div class="no-data" v-if="!isLoading && daodianList.length === 0">
        暂无符合条件的数据
      </div>

      <div
        v-for="(item, index) in daodianList"
        :key="item.id"
        class="data-card"
        @click="toFollowRecord(item.id)"
      >
        <div class="card-header">
          <div class="to-store-type">
            {{ item.leixing?.name || '未知类型' }}
          </div>
          <div class="status-tag" v-if="item.is_lost">
            已流失
          </div>
          <div class="status-tag signed" v-if="item.is_signed">
            已签约
          </div>
        </div>

        <div class="card-body">
          <div class="info-row primary-info">
            <div class="customer-name">{{ item.name || '-' }}</div>
            <div class="age">{{ item.age ? item.age + '岁' : '-' }}</div>
            <span
              class="intention-tag"
              :class="{
                'high': item.yixiangdu === 'A',
                'middle': item.yixiangdu === 'B',
                'low': item.yixiangdu === 'C'
              }"
            >
              {{ item.yixiangdu === 'A' ? '高意向' : item.yixiangdu === 'B' ? '中意向' : '低意向' }}
            </span>
          </div>

          <div class="info-row secondary-info">
            <i class="el-icon-phone-outline contact-icon"></i>
            <span class="contact-value">{{ item.phone || '-' }}</span>
          </div>

          <div class="info-row tertiary-info">
            <div class="update-time">
              <i class="el-icon-time time-icon"></i>
              <span>{{ formatDate(item.update_time) || '无记录' }}</span>
            </div>
            <el-button
              type="primary"
              class="detail-btn"
              size="mini"
            >
              查看详情
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页组件 -->
    <el-pagination
      v-if="total > 0"
      v-model:current-page="pagination.currentPage"
      v-model:page-size="pagination.pageSize"
      :page-sizes="[10, 20, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total"
      @size-change="handlePageSizeChange"
      @current-change="handlePageChange"
      class="mobile-pagination"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from 'axios';
import request from "@/util/request";
import { ElMessage } from "element-plus";
import { ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElDatePicker, ElButton, ElSkeleton, ElPagination } from "element-plus";

export default {
  name: "DaodianMobile",
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElButton,
    ElSkeleton,
    ElPagination
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    // 数据与筛选
    const daodianList = ref([]);
    const leixingList = ref([]);
    const searchForm = ref({
      keyword: "",
      leixingId: "",
      yixiangdu: "",
      followTime: "",
      lost: "",
      signed: ""
    });
    const dateRange = ref([]);

    // 分页与状态
    const pagination = ref({ currentPage: 1, pageSize: 10, total: 0 });
    const total = ref(0);
    const isLoading = ref(false);

    // 日期格式化
    const formatDate = (time) => {
      if (!time) return '';
      try {
        const date = new Date(time);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
      } catch (err) {
        return time.slice(0, 16);
      }
    };

    // 筛选条件变化处理
    const handleFilterChange = () => {
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 日期范围变化
    const handleDateRangeChange = () => {
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 日期清除
    const handleDateClear = () => {
      dateRange.value = [];
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 获取数据列表
    const fetchDaodianList = async () => {
      if (isLoading.value) return;
      isLoading.value = true;
      try {
        const queryParams = {
          pagenum: pagination.value.currentPage,
          pagesize: pagination.value.pageSize,
          keyword: searchForm.value.keyword.trim(),
          leixing_id: searchForm.value.leixingId || "",
          yixiangdu: searchForm.value.yixiangdu || "",
          follow_time: searchForm.value.followTime || "",
          start_date: dateRange.value[0] || "",
          end_date: dateRange.value[1] || "",
          lost: searchForm.value.lost || "",
          signed: searchForm.value.signed || ""
        };

        const res = await request.get("api/daodian/", queryParams);
        if (res.data && typeof res.data === 'object') {
          if (res.data.code === 200) {
            daodianList.value = res.data.data || [];
            total.value = res.data.total || 0;
            pagination.value.total = total.value;
          } else {
            ElMessage.error(res.data.errorInfo || "数据获取失败");
          }
        } else {
          ElMessage.error("接口响应异常");
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          ElMessage.error("网络异常，获取数据失败");
        }
      } finally {
        isLoading.value = false;
      }
    };

    // 分页事件处理
    const handlePageSizeChange = (pageSize) => {
      pagination.value.pageSize = pageSize;
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    const handlePageChange = (currentPage) => {
      pagination.value.currentPage = currentPage;
      fetchDaodianList();
    };

    // 获取到店类型列表
    const getLeixingList = async () => {
      try {
        const res = await request.get("api/leixing/");
        if (res.data && typeof res.data === 'object' && res.data.code === 200) {
          leixingList.value = res.data.data || [];
        } else {
          ElMessage.error(res.data?.errorInfo || "获取类型失败");
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          ElMessage.error("网络异常，获取类型失败");
        }
      }
    };

    // 重置搜索条件
    const resetSearch = () => {
      searchForm.value = {
        keyword: "",
        leixingId: "",
        yixiangdu: "",
        followTime: "",
        lost: "",
        signed: ""
      };
      dateRange.value = [];
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 页面跳转
    const openAddDaodianPage = () => {
      router.push("/mobile/daodian/add");
    };

    const toFollowRecord = (daodianId) => {
      router.push({
        path: "/mobile/daodian/follow",
        query: { daodianId }
      });
    };

    // 监听路由参数变化
    watch(() => route.query, (newQuery) => {
      if (Object.keys(newQuery).length > 0) {
        searchForm.value = {
          keyword: newQuery.keyword || "",
          leixingId: newQuery.leixingId || "",
          yixiangdu: newQuery.yixiangdu || "",
          followTime: newQuery.followTime || "",
          lost: newQuery.lost || "",
          signed: newQuery.signed || ""
        };
        if (newQuery.startDate && newQuery.endDate) {
          dateRange.value = [newQuery.startDate, newQuery.endDate];
        } else {
          dateRange.value = [];
        }
        fetchDaodianList();
      }
    }, { immediate: true });

    // 初始化加载
    onMounted(() => {
      getLeixingList();
      if (Object.keys(route.query).length === 0) {
        fetchDaodianList();
      }
    });

    return {
      daodianList,
      leixingList,
      searchForm,
      pagination,
      total,
      isLoading,
      dateRange,
      formatDate,
      fetchDaodianList,
      handlePageSizeChange,
      handlePageChange,
      getLeixingList,
      resetSearch,
      openAddDaodianPage,
      toFollowRecord,
      handleDateRangeChange,
      handleDateClear,
      handleFilterChange
    };
  },
};
</script>

<style scoped>
/* 基础样式保持不变 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, html, .app-container {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.app-container {
  padding: 10px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.filter-area {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  width: 100%;
}

/* 核心：固定提示栏样式（所有人可见） */
.loss-tip {
  background-color: #e8f4f8;
  color: #4299e1;
  font-size: 12px;
  padding: 10px 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.tip-icon {
  font-size: 16px;
  color: #4299e1;
}

/* 其他原有样式保持不变 */
.card-header {
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #f56c6c;
  color: white;
}

.status-tag.signed {
  background-color: #52c41a;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 5px;
}

.total-count {
  color: #606266;
  font-size: 14px;
}

.loading {
  color: #409eff;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.data-card {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.2s;
  width: 100%;
  max-width: 100%;
}

.data-card:active {
  transform: scale(0.99);
}

.to-store-type {
  color: #409eff;
  font-size: 15px;
  font-weight: 500;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  width: 100%;
  flex-wrap: nowrap;
}

.primary-info {
  justify-content: space-between;
}

.customer-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
}

.age {
  color: #606266;
  font-size: 14px;
  margin: 0 8px;
}

.intention-tag {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  color: #fff;
  white-space: nowrap;
}

.intention-tag.high {
  background-color: #67c23a;
}

.intention-tag.middle {
  background-color: #e6a23c;
}

.intention-tag.low {
  background-color: #f56c6c;
}

.secondary-info {
  color: #606266;
  font-size: 14px;
  gap: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tertiary-info {
  justify-content: space-between;
  color: #909399;
  font-size: 13px;
}

.contact-icon, .time-icon {
  font-size: 14px;
}

.detail-btn {
  padding: 4px 10px;
}

.no-data {
  text-align: center;
  padding: 30px 0;
  color: #909399;
  background: #fff;
  border-radius: 8px;
  width: 100%;
}

.mobile-pagination {
  margin-top: 20px;
  text-align: center;
  padding: 10px 0;
  width: 100%;
  overflow: hidden;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .filter-form {
    flex-direction: column;
    align-items: stretch;
  }

  .el-form-item {
    margin-bottom: 10px !important;
    width: 100%;
  }

  .el-input, .el-select, .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
  }

  .el-form-item:last-child {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
  }

  .el-form-item:last-child .el-button {
    flex: 1;
    min-width: 80px;
  }

  .customer-name {
    max-width: 50%;
  }

  .age {
    margin: 0 4px;
  }
}

@media (max-width: 375px) {
  .app-container {
    padding: 8px 5px;
  }

  .data-card {
    padding: 16px 12px;
  }

  .intention-tag {
    padding: 2px 6px;
    font-size: 11px;
  }

  .detail-btn {
    padding: 3px 8px;
    font-size: 11px;
  }

  .loss-tip {
    font-size: 20px;
    padding: 12px 15px;
  }
}
</style>